import { EventType } from './eventmodels.js'
import { Logger } from '../logging/logger.js'

class CacheControllerClass {
	/**
	 * Processes the cache event.
	 * @param {RCEvent} event 
	 */
	processEvent(event) {
		if (!event || !event.data) {
			Logger.log("Invalid event")
			return;
		}

		switch (event.data.eventType) {
			case EventType.READ_CACHE:
				this.readCache(event);
				break;

			case EventType.WRITE_CACHE:
				this.writeCache(event);
				break;

			case EventType.CLEAR_CACHE:
				this.clearCache(event);
				break;

			default:
				Logger.log("Invalid event type")
				if (event.callback) {
					event.callback.onFailure("Invalid event type")
				}
		}
	}

	/**
	 * Reads the given key from persistent storage.
	 * @param {RCEvent} event - Event containing the key data.
	 */
	readCache(event) {
		if (event.data.cacheKey) {
			const result = localStorage.getItem(event.data.cacheKey);
			if (result) {
				event.callback.onSuccess(JSON.parse(result));
			}
			else
				event.callback.onFailure("Error retrieving key");
		} else {
			event.callback.onFailure("Invalid key");
		}
	}

	/**
	 * Writes the given key and value to persistent storage.
	 * @param {RCEvent} event - Event containing the key and value.
	 */
	writeCache(event) {
		if (!event.data.cacheKey) {
			event.callback.onFailure("Invalid key");
			return;
		}
		const value = event.data.cacheValue
		localStorage.setItem(event.data.cacheKey, JSON.stringify(value));
		event.callback.onSuccess(event.data.cacheValue);
	}

	/**
	 * Clears the given key from persistent storage.
	 * @param {RCEvent} event - Event containing the key.
	 */
	clearCache(event) {
		if (!event.data.cacheKey) {
			event.callback.onFailure("Invalid key");
			return;
		}
		localStorage.removeItem(event.data.cacheKey);
		event.callback.onSuccess(null);
	}
}
export const CacheController = new CacheControllerClass()
